// @flow
import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { ISO_DATE } from 'common/domain/DateRange';
import { WEEK_START } from 'common/domain/week';

const SText = styled.text`
  font-size: ${({ theme }) => theme.fonts.style.small.fontSize}px;
  font-weight: ${({ theme }) => theme.fonts.weights.lighter};
`;

type Props = {
  x: number;
  y: number;
  payload: any;
  weekly: boolean;

  t: any;
}

const JANUARY = 0;

function HistoryGraphTick(props: Props) {
  const { x, y, payload, weekly, t } = props;
  const date = moment(payload.value, ISO_DATE);

  let label;
  if (!weekly) {
    if (date.date() !== 1) {
      return null;
    }

    if (date.month() === JANUARY) {
      label = `${date.format('MMMM')} ${date.year()}`;
    } else {
      label = date.format('MMMM');
    }
  } else {
    if (date.isoWeekday() !== WEEK_START) {
      return null;
    }
    label = t('date.standard', { value: date });
  }

  return (
    <g transform={`translate(${x},${y})`}>
      <SText x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-40)">{label}</SText>
    </g>
  );
}

export default translate()(HistoryGraphTick);



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/components/HistoryGraphTick.js